import { colors, fontFamilies } from '@configs/styles/config'
import { useAuth } from '@contexts/Auth'
import styled from '@emotion/styled'
// import { useScrollPosition } from '@nextui-org/react'
import { Button } from '@nextui-org/react-latest'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

type Props = {
  title: string
  description: string
  handleBecomeCreator?: () => void
}

const HeroSection = ({ title, description, handleBecomeCreator }: Props) => {
  const { t } = useTranslation('advantageous')
  const { user } = useAuth()
  const router = useRouter()

  return (
    <Container>
      {/* <div className="w-1/2 h-3/4 bg-pink-600 absolute top-[10%] left-2 blur-[80px] bg-opacity-10 rounded-full" />
      <div className="w-1/2 h-3/4 bg-uguPurple absolute top-[20%] right-2 blur-[80px] bg-opacity-10 rounded-full" /> */}
      <Wrapper>
        <TopPart>
          <TagBlocksWrapper className="hidden md:flex gap-[24px]">
            <TagBlock className="shadow-sm">{t('tagBlocks.noFee')}</TagBlock>
            <TagBlock className="shadow-sm">{t('tagBlocks.aiTools')}</TagBlock>
            <TagBlock className="shadow-sm">
              {t('tagBlocks.highProfits')}
            </TagBlock>
          </TagBlocksWrapper>
          <TopPartHeading>{title}</TopPartHeading>
          <TopPartSubHeading>{description}</TopPartSubHeading>
        </TopPart>
        <TagBlocksWrapper className="flex md:hidden gap-[8px]">
          <TagBlock>{t('tagBlocks.noFee')}</TagBlock>
          <TagBlock>{t('tagBlocks.aiTools')}</TagBlock>
          <TagBlock>{t('tagBlocks.highProfits')}</TagBlock>
        </TagBlocksWrapper>
        <BottomPart>
          <Button
            color="primary"
            className="font-sofiaPro font-[400] lg:text-lg md:text-base rounded-full px-[3rem] py-[2rem]"
            onPress={() =>
              handleBecomeCreator
                ? handleBecomeCreator()
                : router.push('/author/become-author/')
            }
          >
            {t(user?.isAuthor ? 'buttons.dashboard' : 'buttons.becomeAuthor')}
          </Button>
          {/* <BottomPartCaption>
            No Fee, AI Powered, High Profits
          </BottomPartCaption> */}
        </BottomPart>
      </Wrapper>
    </Container>
  )
}

export default HeroSection

const Container = styled.div`
  height: 657px;
  /* background-color: ${(props) => (props.y < 520 ? '#E7EAFF' : '')}; */
  transition: all 0.2s ease-in-out;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 128px;
  @media screen and (max-width: 1024px) {
    padding-top: 96px;
  }
`

const Wrapper = styled.div`
  width: 100%;
  max-width: 75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
`
const TopPart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`
const TopPartHeading = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-weight: 600;
  line-height: 4.47rem;
  font-size: 4.37rem;
  color: ${colors.uguPurple};
  text-align: center;
  @media screen and (max-width: 1024px) {
    line-height: 4rem;
    font-size: 4rem;
  }
  @media screen and (max-width: 596px) {
    line-height: 2.25rem;
    font-size: 2.25rem;
    max-width: 311px;
  }
`
const TopPartSubHeading = styled.div`
  font-size: 1.5rem;
  line-height: 32.68px;
  text-align: center;
  max-width: 690px;
  font-family: ${fontFamilies.OpenSansRegular};
  font-weight: 500 !important;
  color: ${colors.uguPurple};
  @media screen and (max-width: 1024px) {
    font-size: 1.5rem;
    line-height: 32.68px;
    padding: 0px 1rem;
  }
  @media screen and (max-width: 596px) {
    line-height: 21.79px;
    font-size: 16px;
    max-width: 300px;
  }
`

const BottomPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`

const TagBlocksWrapper = styled.div``
const TagBlock = styled.div`
  padding: 10px 24px 10px 24px;
  background-color: #e7eaff;
  font-weight: 500;
  border-radius: 50px;
  color: ${colors.uguPurple};
  font-family: ${fontFamilies.sofiaPro};
  font-size: 1rem;
  /* line-height: 1rem; */
  @media screen and (max-width: 596px) {
    font-size: 0.8rem;
    line-height: 0.8rem;
  }
`

// const BottomPartCaption = styled.div`
//   font-family: ${fontFamilies.OpenSansRegular};
//   font-size: 14px;
//   font-weight: 500;
//   line-height: 19.07px;
//   text-align: center;
//   text-decoration: underline;
//   color: ${colors.uguPurple};
// `
